<template>
  <el-dialog
      :title="title"
      :visible.sync="modelValue"
      :close-on-click-modal="false"
      custom-class="custom-dialog-class"
      append-to-body
      width="30%"
      :before-close="handleClose">
    <template #default >
      <div class="dialog-container" >
        <p class="label" >{{ `${title}：` }}</p>
        <p class="value" >{{ text }}</p>
      </div>
    </template>
    <template #footer >
      <div class="dialog-footer">
        <el-button type="primary" @click="handleClose(cancel_handler)">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "SeeAllergyTaboo",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: () => ""
    },
    state: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {

    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    title() {
      let str = "";
      switch (this.state) {
        case "allergy":
          str = "食物过敏史";
          break;
        case "taboo":
          str = "饮食禁忌";
          break;
      }
      return str;
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    cancel_handler() {
      this.modelValue = false;
    },
    handleClose(done) {
      done();
    },
  }
}
</script>

<style scoped lang="scss">
.dialog-container{
  width: 400px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  .label{
    width: max-content;
  }
  .value{
    flex: 1;
  }
}
</style>
